"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var QuoraAccount_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoraAccount = void 0;
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const sioc_1 = require("lincd-sioc/lib/ontologies/sioc");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const ShapeSet_1 = require("lincd/lib/collections/ShapeSet");
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const titan_ads_1 = require("../ontologies/titan-ads");
const package_1 = require("../package");
const TitanShapes_1 = require("./TitanShapes");
const Audience_1 = require("./Audience");
const Question_1 = require("./Question");
const Location_1 = require("./Location");
const Topic_1 = require("./Topic");
let QuoraAccount = QuoraAccount_1 = class QuoraAccount extends Shape_1.Shape {
    constructor(node) {
        super(node);
        this.cachedAudiences = [];
    }
    static async loadAll(forceRefresh = false) {
        if (forceRefresh) {
            const quoraAccounts = await Server_1.Server.call(this, 'fetchFromQuora');
            return quoraAccounts;
        }
        return Server_1.Server.call(package_1.packageName, 'loadAll', QuoraAccount_1.shape.namedNode);
    }
    async getAudiences(useCache = true) {
        console.log(Audience_1.Audience.targetClass);
        if (useCache && this.cachedAudiences.length) {
            return this.cachedAudiences;
        }
        const audiences = await Server_1.Server.call(this, 'getAudiences');
        this.cachedAudiences = audiences;
        return audiences;
    }
    async getLocations(query, ignoreIds) {
        console.log(Location_1.Location.targetClass);
        return Server_1.Server.call(this, 'getLocations', query, ignoreIds);
    }
    async getQuestions(query) {
        console.log(Question_1.Question.targetClass);
        return Server_1.Server.call(this, 'getQuestions', query);
    }
    async getTopics(query) {
        // console.log(Topic.targetClass);
        return Server_1.Server.call(this, 'getTopics', query).then(topicData => {
            return (topicData || []).map(Topic_1.Topic.fromQuoraResponse);
        });
        // .then(topics => {
        //   return topics ? topics.map(Topic.fromQuoraResponse) : [];
        // })
    }
    async validateAnswerURL(url) {
        return Server_1.Server.call(this, 'validateAnswerURL', url);
    }
    get brands() {
        return TitanShapes_1.BrandAccount.getSetOf(this.getAllInverse(titan_ads_1.titanAds.quoraAccount));
    }
    get id() {
        return Number.parseInt(this.getValue(sioc_1.sioc.id));
    }
    set id(val) {
        this.overwrite(sioc_1.sioc.id, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get quoraId() {
        return this.id;
    }
    get accountId() {
        return Number.parseInt(this.getValue(titan_ads_1.titanAds.accountId));
    }
    set accountId(val) {
        this.overwrite(titan_ads_1.titanAds.accountId, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get mediaId() {
        return Number.parseInt(this.getValue(titan_ads_1.titanAds.mediaId));
    }
    set mediaId(val) {
        this.overwrite(titan_ads_1.titanAds.mediaId, new models_1.Literal(`${val}`, xsd_1.xsd.integer));
    }
    get name() {
        return this.getValue(sioc_1.sioc.name);
    }
    set name(val) {
        this.overwrite(sioc_1.sioc.name, new models_1.Literal(val));
    }
};
exports.QuoraAccount = QuoraAccount;
QuoraAccount.targetClass = titan_ads_1.titanAds.QuoraAccount;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.hasBrands,
        // required: true,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], QuoraAccount.prototype, "brands", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.id,
        required: true,
        dataType: xsd_1.xsd.integer,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], QuoraAccount.prototype, "id", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.accountId,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], QuoraAccount.prototype, "accountId", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.mediaId
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], QuoraAccount.prototype, "mediaId", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.name,
        required: true,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], QuoraAccount.prototype, "name", null);
exports.QuoraAccount = QuoraAccount = QuoraAccount_1 = __decorate([
    package_1.linkedShape,
    __metadata("design:paramtypes", [models_1.NamedNode])
], QuoraAccount);
//# sourceMappingURL=QuoraAccount.js.map